// Shared storage helper для Zustand `persist`.
// Использует localStorage с graceful fallback (SSR / blocked storage).
// Для очень больших данных (запись лекций) — отдельный idb-keyval адаптер,
// здесь не нужен.
import { createJSONStorage, type StateStorage } from "zustand/middleware";

const memoryStore = new Map<string, string>();

const safeLocalStorage: StateStorage = {
	getItem: (name) => {
		try {
			if (typeof window === "undefined") return memoryStore.get(name) ?? null;
			return window.localStorage.getItem(name);
		} catch {
			return memoryStore.get(name) ?? null;
		}
	},
	setItem: (name, value) => {
		try {
			if (typeof window === "undefined") {
				memoryStore.set(name, value);
				return;
			}
			window.localStorage.setItem(name, value);
		} catch {
			memoryStore.set(name, value);
		}
	},
	removeItem: (name) => {
		try {
			if (typeof window === "undefined") {
				memoryStore.delete(name);
				return;
			}
			window.localStorage.removeItem(name);
		} catch {
			memoryStore.delete(name);
		}
	},
};

export const persistStorage = createJSONStorage(() => safeLocalStorage);
